// extracted by mini-css-extract-plugin
module.exports =  {"internalLink":"style-module_internalLink__FgFXzmzkg2rvXMsSVbEW","listInternalLink":"style-module_listInternalLink__FWY5G7oJs0ZULEL5DzTY"};